<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.fdumTitle" style="width: 180px;" size="mini" placeholder="标题"
                        clearable></el-input>
                    <el-select v-model="formDatas.fdumStatus" placeholder="状态" size="mini" style="width: 160px;"
                        @change="partserch" clearable>
                        <el-option label="待发送" :value="1"></el-option>
                        <el-option label="已发送" :value="2"></el-option>
                        <el-option label="已取消" :value="3"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量撤销</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px"
                        @click="BoxOpen">新增机器人消息</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="fdumId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑机器人消息' : '新增机器人消息'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="用户" prop="fdumUserIds">
                                <el-radio-group v-model="isSbAsType">
                                    <el-radio label="0">选择钉钉用户</el-radio>
                                    <el-radio label="1">上传文件</el-radio>
                                </el-radio-group>
                                <div v-if="isSbAsType == '0'" style="margin-top: 10px;">
                                    <el-select v-model="form.fdumUserIds" multiple filterable clearable
                                        placeholder="请选择钉钉用户" style="width: 80%;">
                                        <el-option v-for="item in getFxxkDingUserList_data" :key="item.fduId"
                                            :label="item.name" :value="item.fduId">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-if="isSbAsType == '1'" style="margin-top: 10px;">
                                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls"
                                        :on-change="updatabulk" :auto-upload="false" ref="bulk" multiple>
                                        <el-button size="medium" type="danger">点击上传</el-button>
                                    </el-upload>
                                    <div v-if="form.fdumUserIds.length > 0">已选择{{ form.fdumUserIds.length }}个用户</div>
                                      <div v-if="arrFail.length > 0">无效用户:</div>
                                    <el-table v-if="arrFail.length > 0" :data="arrFail" stripe border
                                        style="width: 100%" :max-height="300" :cell-style="{ textAlign: 'center' }"
                                        :header-cell-style="{
                                            textAlign: 'center',
                                            background: 'rgba(0,170,255,0.5)',
                                            color: 'black',
                                            border: 'none',
                                        }">
                                        <el-table-column prop="name" label="姓名">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="标题" prop="fdumTitle">
                                <el-input v-model="form.fdumTitle" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="内容" prop="fdumContent">
                                <el-input v-model="form.fdumContent" type="textarea" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item label="状态" prop="fdumStatus">
                                <el-select v-model="form.fdumStatus" placeholder="请选择" style="width: 80%;">
                                    <el-option label="待发送" :value="1"></el-option>
                                    <el-option label="已发送" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 发送记录详情 -->
            <el-dialog title="发送记录详情" :visible.sync="diaDetail" width="80%" :before-close="diaDetailClose"
                style="margin-left: 200px;">
                <el-row style="margin: 10px auto; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formMsg.fdumsStatus" placeholder="发送状态" size="mini" @change="partserchDetail"
                        style="width: 120px;" clearable>
                        <el-option label="成功" :value="1"></el-option>
                        <el-option label="失败" :value="2"></el-option>
                    </el-select>
                    <!-- <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                   -->
                </el-row>
                <div>
                    <ve-table :columns="columnsDetail" :table-data="tableDataDetail" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableDataDetail.length == 0" class="empty-data">暂无数据</div>
                    <div class="table-pagination">
                        <ve-pagination :total="totalCountMsg" :page-index="formMsg.currentPage"
                            :page-size="formMsg.pageSize"
                            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                            @on-page-number-change="pageNumberChange2" @on-page-size-change="pageSizeChange2" />
                    </div>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { updateFxxkDingUserMsgSendRepeat, getFxxkDingUserMsgSendList, getFxxkDingUserList, updateFxxkDingUserMsgSend, updateFxxkDingUserMsgCancel, getFxxkDingUserMsgList, addFxxkDingUserMsg, updateFxxkDingUserMsg, uploadFxxkDingUserReturnIdsList } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            arrFail:[],
            isSbAsType: '0',
            bulkImport: false,
            columnsDetail: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: "用户名",
                    align: "center",
                    edit: false,
                },
                {
                    field: "fdumsStatus",
                    key: "fdumsStatus",
                    title: "发送状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fdumsStatus === 1 ? <el-tag size="mini" type="success">成功</el-tag> :
                                        row.fdumsStatus === 2 ? <el-tag size="mini" type="danger">失败</el-tag> :
                                            <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "fdumsStatusDes",
                    key: "fdumsStatusDes",
                    title: "状态备注",
                    align: "center",
                    edit: false,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 160,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>


                                {
                                    row.fdumsStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleRest(row)}
                                    >
                                        重新发送
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ],
            bulkData: [],

            getFxxkDingUserList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'fdumId',
            dialog: false,
            edit: false,
            form: {
                fdumUserIds: []
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            totalCountMsg: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "fdumTitle",
                    key: "fdumTitle",
                    title: "标题",
                    align: "center",
                    edit: false,
                },
                {
                    field: "fdumContent",
                    key: "fdumContent",
                    title: "内容",
                    align: "center",
                    edit: false,
                },

                {
                    field: "fdumStatus",
                    key: "fdumStatus",
                    title: "状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.fdumStatus == 1 ? <el-tag>待发送</el-tag> : row.fdumStatus == 2 ? <el-tag type="success">已发送</el-tag> : <el-tag type="danger">已取消</el-tag>;
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: ##409EFF"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    发送详情
                                </el-button>
                                {
                                    row.fdumStatus != 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button> : ''
                                }

                                {
                                    row.fdumStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDown(row)}
                                    >
                                        暂停
                                    </el-button> : ''
                                }
                                {
                                    row.fdumStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleUp(row)}
                                    >
                                        发布
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formMsg: {
                currentPage: 1,
                pageSize: 20,
            },
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },

            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getFxxkDingUserList({ pageSize: 0 }).then(res => {
            this.getFxxkDingUserList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        diaDetailClose() {
            this.diaDetail = false;
        },
        pageSizeChange2(pageSize) {
            this.formMsg.pageSize = pageSize;
            this.partserchDetail();
        },
        pageNumberChange2(pageIndex) {
            console.log(pageIndex);
            this.formMsg.currentPage = pageIndex;
            getFxxkDingUserMsgSendList(this.formMsg).then(res => {
                this.tableDataDetail = res.data;
                this.totalCountMsg = res.total;
            })
        },
        partserchDetail() {
            this.formMsg.currentPage = 1;
            getFxxkDingUserMsgSendList(this.formMsg).then(res => {
                this.tableDataDetail = res.data;
                this.totalCountMsg = res.total;
            })
        },
        handleDetail(row) {
            this.formMsg.fdumId = row.fdumId;
            this.partserchDetail();
            this.diaDetail = true;
        },
        handleRest(row) {
            this.$confirm("是否确定要重新发送吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateFxxkDingUserMsgSendRepeat({ fdumsId: row.fdumsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "重新发送成功!",
                            });

                            this.partserchDetail()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleDown(row) {
            this.$confirm("是否确定要暂停吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateFxxkDingUserMsgCancel({ fdumId: row.fdumId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "暂停成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleUp(row) {
            this.$confirm("是否确定要发布吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.openLoading()
                    updateFxxkDingUserMsgSend({ fdumId: row.fdumId }).then(res => {
                        if (res.status == 200) {
                            this.loadings.close()
                            if (res.data.length > 0) {
                                this.$message({
                                    type: "info",
                                    message: `有${res.data.length}个用户发送失败，请点击查看详情`,
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: "发布成功!",
                                });
                            }
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            this.form.fdumUserIds = [];
            this.arrFail = []
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadFxxkDingUserReturnIdsList(Data).then(res => {
                if (res.data.length == 0) {
                    this.$message({
                        showClose: true,
                        message: "上传失败，请检查文件内容",
                        type: 'danger'
                    });
                    this.loadings.close()
                    return
                }
                this.loadings.close()
                res.data.forEach((item, index) => {
                    if (item.fduId) {
                        this.form.fdumUserIds.push(item.fduId)
                    }else {
                        this.arrFail.push(item)
                    }
                })
            })
        },
        bulkImportClose(done) {
            done();
            this.bulkData = [];
            this.$nextTick(() => {
                this.getList()
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record/exportAjefCertificateRecord',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '机器人消息.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },

        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ fdumId: this.theRow.fdumId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ fdumIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefShopStockYidong({ fdumId: row.fdumId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            data.fdumUserIds = data.fdumUserIds ? JSON.parse(data.fdumUserIds) : [];
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        newForm.fdumUserIds = newForm.fdumUserIds ? JSON.stringify(newForm.fdumUserIds) : '';
                        addFxxkDingUserMsg(newForm).then(res => {
                            if (res.status == 200) {
                                if (res.data.length > 0) {
                                    this.$message({
                                        type: "info",
                                        message: `有${res.data.length}个用户发送失败，请点击查看详情`,
                                    });
                                } else {
                                    this.$message({
                                        type: "success",
                                        message: "发布成功!",
                                    });
                                }
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        newForm.fdumUserIds = newForm.fdumUserIds ? JSON.stringify(newForm.fdumUserIds) : '';
                        updateFxxkDingUserMsg(newForm).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.arrFail = [];
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fdumId = row.fdumId
                    console.log(jsonObj);
                    updateFxxkDingUserMsg(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkDingUserMsgList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkDingUserMsgList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkDingUserMsgList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>